<template>
  <div style="height: 100%">
    <component
      ref="componentRef"
      :is="template"
      :date="date"
      :time="time"
      :notes.sync="notes"
      :phone="phone"
      :fdAction.sync="fdAction"
      :language="language"
      :showPhone="showPhone"
      :stringList="stringList"
      :roomNumber="roomNumber"
      :notFoundContent="notFoundContent"
      :roomArray="roomArray"
      :meetingService="meetingService"
      :meetingServiceType="meetingServiceType"
      :meetingRequest.sync="meetingRequest"
      :showDate="showDate"
      :primaryColor="primaryColor"
      :showTime.sync="showTime"
      :timeColumns="timeColumns"
      :confirmationPop="confirmationPop"
      :selectRequest="selectRequest"
      :confirmation1="confirmation1"
      :confirmation="confirmation"
      :thankPop2="thankPop2"
      :thankPop3="thankPop3"
      :thankPop="thankPop"
      :meetingServiceTitle="meetingServiceTitle"
      :tips="tips"
      :pageType="pageType"
      :okContent="okContent"
      :fileList="fileList"
      @onClickLeft="onClickLeft"
      @roomSearch="(val) => roomSearch(val)"
      @roomChange="(val) => roomChange(val)"
      @clearRoomNumber="clearRoomNumber"
      @focusMeetingRequest="(str) => focusMeetingRequest(str)"
      @deteSelect="deteSelect"
      @selectTime="selectTime"
      @validateMobile="(val) => validateMobile(val)"
      @dateConfirm="(val) => dateConfirm(val)"
      @timeConfirm="(val) => timeConfirm(val)"
      @confirmationPopOK="confirmationPopOK"
      @showPdf="(keyword, file) => showPdf(keyword, file)"
      @pdfView="(inno, title) => pdfView(inno, title)"
      @createOrder="createOrder"
    />
  </div>
</template>

<script>
import TemplateA from "./MeetingServiceTemplate/templateA.vue";
import TemplateB from "./MeetingServiceTemplate/templateB.vue";

import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import moment from "moment-timezone";
import { postAction, getAction } from "@/api/manage";
import { Toast } from "vant";
import { encryptedDES } from "@/utils/DES.js";
import { set } from "nprogress";

export default {
  components: {
    TemplateA,
    TemplateB,
  },

  metaInfo: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no",
      },
    ],
  },
  name: "MeetingService",
  data() {
    return {
      requestList: [],
      otherRequestList: [],
      overNightHours: Vue.ls.get("overNightHours"),
      url: {
        isservicehour: "/api/app/current_user/isservicehour/",
        createOrder: "/api/common/hotel/data/qrorder/create",
        login: "/api/common/user/hotel_dept_name/login",
        hotelQuery: "/api/sys_admin/hotel/query",
        hotelinfo: "/adminApi/hotelinfo/infobyhotel",
        getPageInfo: "/adminApi/file/page",
        queryRoomNum: "/api/sys_admin/hotel/room/query2/",
        getKeyWord: "/api/app/current_user/keywordsalldept/",
        getReplyList: "/adminApi/reply/listbyhotel",
        getIsInputPhone: "/adminApi/textconfig/list",
        getFileList: "/adminApi/file/filelist",
        getLanguageList: "/api/common/hotel/data/dict/by_key/languageQr",
        about: "/adminApi/test/qr/about1",
      },

      roomNumber: "",
      notes: "",
      date: "",
      showDate: false,
      time: "",
      showTime: false,
      roomArray: [],
      phone: "",
      timeColumns: [],
      selectRequest: {},

      requestPop: true,
      searchRequest: undefined,

      //特殊流程
      confirmationPop: false,
      fdAction: "",
      confirmation: "",
      tips: "",
      thankPop: false,
      okContent: "",
      //防止多次提交
      submiting: false,
      thankPop2: false, //TransferToFD或者TransferToRS yes分支弹窗
      thankPop3: false, //Answer分支弹窗
      timeDisabled: true, //时间不可选

      notFoundContent: "",
      fileList: Vue.ls.get("fileList"),
      language: Vue.ls.get("language"),
      stringList: {},
      confirmation1: "",
      meetingService: "",
      meetingRequest: "",
      meetingServiceType: "",
      meetingServiceTitle: "",
      pageType: Vue.ls.get("type"),
      serviceTitle: {
        "AV Assistance": "AV_Assistance",
        "Beverage/Coffee Refill": "Beverage",
        "Breaktime/Mealtime Change": "Breaktime",
        "Request Hotel Staff": "Request_Hotel_Staff",
        "Temperature Control": "Temperature_Control",
        "Other/Miscellaneous": "Miscellaneous",
      },
      color: "",
    };
  },
  watch: {
    // storeTemplate: {
    //   handler(newVal) {
    //     console.log("storeTemplate", newVal);
    //     if (newVal) {
    //       this.template = newVal;
    //     }
    //   },
    //   immediate: true,
    // },
    // storeH5HeaderBg: {
    //   handler(newVal) {
    //     if (newVal) {
    //       this.h5HeaderBg = newVal;
    //     }
    //   },
    //   immediate: true,
    // },
    allRequest() {
      if (this.requestList.length == 0) {
        this.requestList = this.allRequest.filter((item) => {
          if (item.serviceType == "Service") {
            return item;
          }
        });
      }
    },
    meetingRequest(n, o) {
      if (n.length >= 50) {
        Toast({
          message:
            `<div style="word-break: normal;font-size:14px;width="300px"><span>` +
            this.stringList.limit_request_description +
            `</span></div>`,
          type: "html",
        });
        return;
      }
    },
    notes(n, o) {
      if (n.length >= 200 && n.length != 0 && this.language == "ar") {
        Toast({
          message:
            `<div style="word-break: normal;font-size:14px;width=300px;direction:rtl"><span>` +
            this.stringList.limit_description +
            `</span></div>`,
          type: "html",
        });
      } else if (n.length >= 200 && n.length != 0) {
        Toast({
          message:
            `<div style="word-break: normal;font-size:14px;width=300px"><span>` +
            this.stringList.limit_description +
            `</span></div>`,
          type: "html",
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      allRequest: "informationRequest", //所有request
      roomList: "roomList",
      showPhone: "showPhone",
      primaryColor: "primaryColor",
      amcniticsRequest: "amcniticsRequest",
      informationRequest: "informationRequest",
    }),
    template: {
      get() {
        return this.$store.state.config.template;
      },
      set(value) {
        this.$store.commit("setTemplate", value);
      },
    },
    h5HeaderBg: {
      get() {
        return this.$store.state.config.h5HeaderBg;
      },
      set(value) {
        this.$store.commit("setH5HeaderBg", value);
      },
    },
    modifiedColor() {
      // 计算新的颜色
      if (this.isEventTriggered) {
        const originalColor = this.primaryColor;
        // 解析颜色值，假设颜色值是16进制形式
        const hexColor = originalColor.replace("#", "");
        const r = parseInt(hexColor.slice(0, 2), 16);
        const g = parseInt(hexColor.slice(2, 4), 16);
        const b = parseInt(hexColor.slice(4, 6), 16);

        // 加重30%
        const newR = Math.min(255, r * 1.3);
        const newG = Math.min(255, g * 1.3);
        const newB = Math.min(255, b * 1.3);

        // 转换回16进制颜色
        const newHexColor = `#${Math.round(newR)
          .toString(16)
          .padStart(2, "0")}${Math.round(newG)
          .toString(16)
          .padStart(2, "0")}${Math.round(newB).toString(16).padStart(2, "0")}`;
        return newHexColor;
      } else {
        return this.primaryColor; // 未触发事件时返回原始颜色
      }
    },
  },
  async created() {
    // this.template = this.$store.state.config.template;
    // this.h5HeaderBg = this.$store.state.config.h5HeaderBg;
    //无痕浏览器直接进入逻辑
    let tsp = this.$route.query.tsp;
    let now = new Date().getTime();
    console.log(now - tsp * 1000);
    this.roomNumber = Vue.ls.get("room") ? Vue.ls.get("room") : undefined;
    if (now - this.tsp * 1000 > 1000 * 60 * 60 * 24) {
      //如果是走了这个about 后台调用一下接口 打log
      getAction(this.url.about).then((res) => {});
      this.$router.push({ name: "About" });
    } else {
      if (Vue.ls.get("meeting_service")) {
        // this.meetingService = this.$route.query.service
        this.meetingServiceType = Vue.ls.get("meeting_service");
        this.meetingService = this.serviceTitle[this.meetingServiceType];
        getAction(
          `${this.url.queryRoomNum}${"Meeting Room"}/${"allmeeting"}`
        ).then((res) => {
          if (res.status == 0) {
            this.editRoomList(res.data);
          }
        });
      }
      if (!Vue.ls.get("HTTOKEN")) {
        let params = {
          hotelDeptName: "qrbot",
          hotelName: this.$route.query.inno,
          password: "123456",
        };
        postAction(this.url.login, params).then((res) => {
          if (res.status == 0) {
            this.token = res.data.token;
            Vue.ls.set("HTTOKEN", res.data.token);
            getAction(this.url.getLanguageList).then((res) => {
              Vue.ls.set("languageList", res.data);
            });
            postAction(this.url.hotelQuery, {
              hotelNo: this.$route.query.inno,
            }).then((res) => {
              if (res.status == 0) {
                Vue.ls.set("hotelName", res.data.name, 1000 * 60 * 60 * 24);
                Vue.ls.set("timeZone", res.data.timeZone, 1000 * 60 * 60 * 24);
                Vue.ls.set("hotelId", res.data.id, 1000 * 60 * 60 * 24);
                //判断是否启动夜间模式
                Vue.ls.set(
                  "overNightHoursInfo",
                  res.data.overNightHours,
                  1000 * 60 * 60 * 24
                );
                // if (
                //   res.data.overNightHours != "disable" &&
                //   res.data.overNightHours != "Regular Operating Hour"
                // ) {
                //   Vue.ls.set("overNightHours", true, 1000 * 60 * 60 * 24);
                // } else {
                //   Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
                // }
                if (
                  res.data.overNightHours == "disable" ||
                  res.data.overNightHours == "Regular Operating Hour"
                ) {
                  Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
                } else if (
                  res.data.overNightHours == "Cycle Regular Operating Hour"
                ) {
                  // Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
                  let now = new Date();
                  let taody = moment(now)
                    .tz(res.data.timeZone)
                    .format("YYYY/MM/DD");
                  let startTime = moment.tz(
                    moment(taody + " " + res.data.fdStartTime).format(
                      "YYYY-MM-DD HH:mm"
                    ),
                    res.data.timeZone
                  );
                  let endTime = moment.tz(
                    moment(
                      res.data.fdEndTime.replace("tomorrow_", taody + " ")
                    ).format("YYYY-MM-DD HH:mm"),
                    res.data.timeZone
                  );
                  if (this.getIsInTimeRange(startTime, endTime)) {
                    Vue.ls.set("overNightHours", true, 1000 * 60 * 60 * 24);
                  } else {
                    Vue.ls.set("overNightHours", false, 1000 * 60 * 60 * 24);
                  }
                } else {
                  Vue.ls.set("overNightHours", true, 1000 * 60 * 60 * 24);
                }
                Vue.ls.set(
                  "fdStartTime",
                  res.data.fdStartTime,
                  1000 * 60 * 60 * 24
                );
                Vue.ls.set(
                  "fdEndTime",
                  res.data.fdEndTime,
                  1000 * 60 * 60 * 24
                );

                Vue.ls.set("engHour", res.data.engHour, 1000 * 60 * 60 * 24);
                Vue.ls.set(
                  "engEndTime",
                  res.data.engEndTime,
                  1000 * 60 * 60 * 24
                );
                Vue.ls.set(
                  "engStartTime",
                  res.data.engStartTime,
                  1000 * 60 * 60 * 24
                );
                Vue.ls.set(
                  "engRequestTime",
                  res.data.engRequestTime,
                  1000 * 60 * 60 * 24
                );
                getAction(this.url.hotelinfo, { hotelId: res.data.id }).then(
                  (r) => {
                    if (r.status == 0) {
                      this.editColor("#" + r.data.color);

                      const customStyle = JSON.parse(r.data.customStyle);
                      if (customStyle && customStyle.template) {
                        this.template = customStyle.template || "TemplateA";
                        if (customStyle.template == "TemplateB") {
                          this.h5HeaderBg = customStyle.h5HeaderBg;
                        }
                      } else {
                        this.template = "TemplateA";
                      }

                      this.$store.commit("setTemplate", this.template);
                      this.$store.commit("setH5HeaderBg", this.h5HeaderBg);
                      Vue.ls.set("hotelBrand", r.data.brand, 1000 * 60 * 60 * 24);
                    }
                  }
                );
                postAction(this.url.getFileList, { hotelId: res.data.id }).then(
                  (r) => {
                    if (r.status == 0) {
                      Vue.ls.set(
                        "fileList",
                        r.data.htFileList,
                        1000 * 60 * 60 * 24
                      );
                    }
                  }
                );
                let params = {
                  hotelId: Vue.ls.get("hotelId"),
                  type: "internal",
                };
                getAction(this.url.getReplyList, params).then((res) => {
                  if (res.status == 0) {
                    for (let element of res.data) {
                      if (
                        element.botTrigger == "556" ||
                        element.botTrigger == "557"
                      ) {
                        Vue.ls.set(
                          "fdOption",
                          element.botTriggerValue,
                          1000 * 60 * 60 * 24
                        );
                        Vue.ls.set(
                          "fdOptionReponse",
                          element.botResponse2,
                          1000 * 60 * 60 * 24
                        );
                        break;
                      }
                    }
                    for (let element of res.data) {
                      if (element.botTrigger == "677") {
                        Vue.ls.set(
                          "engHourReponse",
                          element.botResponse2,
                          1000 * 60 * 60 * 24
                        );
                        break;
                      }
                    }
                  }
                });
                let form = {
                  hotelId: Vue.ls.get("hotelId"),
                  size: 10,
                  current: 1,
                };
                postAction(this.url.getIsInputPhone, form).then((res) => {
                  if (res.status == 0) {
                    res.data.records.forEach((item) => {
                      if (Vue.ls.get("type") == "guest") {
                        if (item.requestType == "Guest Room Request") {
                          if (item.textResponse == "Disable") {
                            this.editShowPhone(0);
                            return;
                          }
                          if (item.textResponse == "Enable(Optional)") {
                            this.editShowPhone(1);
                            return;
                          }
                          if (item.textResponse == "Enable(Required)") {
                            this.editShowPhone(2);
                            return;
                          }
                        }
                      } else if (Vue.ls.get("type") == "nonguest") {
                        if (item.requestType == "Meeting Room Request") {
                          if (item.textResponse == "Disable") {
                            this.editShowPhone(0);
                            return;
                          }
                          if (item.textResponse == "Enable(Optional)") {
                            this.editShowPhone(1);
                            return;
                          }
                          if (item.textResponse == "Enable(Required)") {
                            this.editShowPhone(2);
                            return;
                          }
                        }
                      }
                    });
                  }
                });
              }
            });
            if (this.amcniticsRequest.length == 0) {
              getAction(`${this.url.getKeyWord}${"fdkey"}`).then((res) => {
                if (res.status == 0) {
                  this.editAmcniticsRequest(res.data);
                }
              });
            }
            if (this.informationRequest.length == 0) {
              getAction(`${this.url.getKeyWord}${"nonfdkey"}`).then((res) => {
                if (res.status == 0) {
                  this.editInformationRequest(res.data);
                }
              });
            }
            debugger;
            if (this.$route.query.type) {
              Vue.ls.set("type", this.$route.query.type, 1000 * 60 * 60 * 24);
              if (Vue.ls.get("type") == "guest") {
                getAction(
                  `${this.url.queryRoomNum}${"guest"}/${"allmeeting"}`
                ).then((res) => {
                  if (res.status == 0) {
                    this.editRoomList(res.data);
                  }
                });
              } else if (Vue.ls.get("type") == "nonguest") {
                getAction(
                  `${this.url.queryRoomNum}${"Meeting Room"}/${"allmeeting"}`
                ).then((res) => {
                  if (res.status == 0) {
                    this.editRoomList(res.data);
                  }
                });
              }
            }
            if (this.$route.query.room) {
              Vue.ls.set("room", this.$route.query.room, 1000 * 60 * 60 * 24);
            }
            if (this.$route.query.inno) {
              Vue.ls.set("inno", this.$route.query.inno, 1000 * 60 * 60 * 24);
            }
          }
        });
        if (!Vue.ls.get("language")) {
          Vue.ls.set("language", "en");
          this.language = "en";
        }
        this.requestList = this.allRequest.filter((item) => {
          if (item.serviceType == "Service") {
            // if (item.section == "Answer") {
            //   console.log(item);
            // }
            return item;
          }
        });
        // 初始化时间控件
        let hour = [];
        for (let i = 1; i <= 12; i++) {
          if (i < 10) {
            hour.push("0" + i);
          } else {
            hour.push("" + i);
          }
        }
        this.timeColumns.push({
          values: hour,
        });
        let minte = [];
        for (let i = 0; i <= 59; i++) {
          if (i < 10) {
            minte.push("0" + i);
          } else {
            minte.push("" + i);
          }
        }
        this.timeColumns.push({
          values: minte,
        });
        this.timeColumns.push({
          values: ["AM", "PM"],
        });
        let languageJsonName = "String_" + Vue.ls.get("language") + ".json";
        this.stringList = await import("@/data/" + languageJsonName);
        this.meetingServiceTitle = this.stringList[this.meetingService];
      } else {
        this.requestList = this.allRequest.filter((item) => {
          if (item.serviceType == "Service") {
            // if (item.section == "Answer") {
            //   console.log(item);
            // }
            return item;
          }
        });
        // 初始化时间控件
        let hour = [];
        for (let i = 1; i <= 12; i++) {
          if (i < 10) {
            hour.push("0" + i);
          } else {
            hour.push("" + i);
          }
        }
        this.timeColumns.push({
          values: hour,
        });
        let minte = [];
        for (let i = 0; i <= 59; i++) {
          if (i < 10) {
            minte.push("0" + i);
          } else {
            minte.push("" + i);
          }
        }
        this.timeColumns.push({
          values: minte,
        });
        this.timeColumns.push({
          values: ["AM", "PM"],
        });
        let languageJsonName = "String_" + Vue.ls.get("language") + ".json";
        this.stringList = await import("@/data/" + languageJsonName);
        console.log(this.stringList);

        this.meetingServiceTitle = this.stringList[this.meetingService];
      }
    }
  },
  methods: {
    moment,
    ...mapActions([
      "editColor",
      "editAmcniticsRequest",
      "editInformationRequest",
      "editShowPhone",
      "editRoomList",
    ]),
    pdfView(inno, title) {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      let urlType = inno.split(".")[inno.split(".").length - 1];
      //创建订单
      let now = new Date();
      let createTime = moment(now).tz(Vue.ls.get("timeZone"));
      let time = new Date().valueOf().toString();
      let params = {
        createTime: createTime.utc().format(),
        fdaction: "",
        fdhour: Vue.ls.get("overNightHoursInfo"),
        hotelId: Vue.ls.get("hotelId"),
        hotelDeptId: "",
        inquiryNum: "",
        notes: "",
        requestType: Vue.ls.get("type"),
        roomNumber: Vue.ls.get("room") ? Vue.ls.get("room") : "GSD",
        requestTime: createTime.utc().format(),
        serviceKey: title ? title : "Guest Service Directory",
        serviceType: "gsd",
        createTimeValue: time,
        tid: encryptedDES(time.substring(time.length - 8)),
        language: this.language,
      };

      if (!this.submiting) {
        this.submiting = true;
        postAction(this.url.createOrder, params)
          .then((res) => {
            if (res.success) {
              this.submiting = false;
            }
          })
          .catch((e) => {
            this.submiting = false;
          });
      }

      if (
        urlType == "xlsx" ||
        urlType == "docx" ||
        urlType == "pptx" ||
        urlType == "xls" ||
        urlType == "doc" ||
        urlType == "ppt"
      ) {
        window.location.href =
          "https://view.officeapps.live.com/op/view.aspx?src=" + inno;
      } else if (
        urlType == "jpg" ||
        urlType == "png" ||
        urlType == "jpeg" ||
        urlType == "gif"
      ) {
        window.location.href = inno;
      } else if (urlType == "pdf") {
        this.$router.push({
          name: "PdfView",
          query: { inno: inno },
        });
      } else {
        window.location.href = inno;
      }
    },
    showPdf(keyword, file) {
      if (!keyword) return false;
      let services = file.service;
      for (let ss of services.split(",")) {
        if (
          keyword.toLowerCase() == ss.toLowerCase() &&
          file.enable != null &&
          file.enable
        ) {
          return true;
        }
      }
      return false;
    },
    claerSearchRequest() {
      this.searchRequest = undefined;
      this.otherRequestList = this.requestList;
    },
    clearRoomNumber() {
      console.log("执行");
      if (this.roomNumber == undefined || this.roomNumber == "") {
        console.log("undefined");
        this.$nextTick(() => {
          this.$refs.componentRef.$refs.select1.blur();
        });
        this.roomArray = this.roomList;
      } else {
        console.log("清除房间号");
        this.roomNumber = "";
        this.roomArray = [];
        this.notFoundContent = "";
        this.$nextTick(() => {
          this.$refs.componentRef.$refs.select1.focus();
        });
        this.roomArray = this.roomList;
      }
    },
    getIsInTimeRange(startTime, endTime) {
      let now = new Date();
      if (startTime.valueOf() < endTime.valueOf()) {
        return (
          startTime.valueOf() <= now.getTime() &&
          now.getTime() <= endTime.valueOf()
        );
      } else {
        return (
          startTime.valueOf() <= now.getTime() ||
          now.getTime() <= endTime.valueOf()
        );
      }
    },
    onClickLeft() {
      // this.$router.go(-1);
      let query = {};
      query.type = this.$route.query.type;
      query.inno = this.$route.query.inno;
      if (this.$route.query.room) {
        query.room = this.$route.query.room;
      }
      query.tsp = this.$route.query.tsp;
      this.$router.replace({ name: "Home", query: query });
    },
    validateMobile(val) {
      //美式mobile 号码格式，3-3-4格式
      //代码参照https://github.com/wuhao000/antd-mobile-vue/blob/master/src/packages/input/src/index.tsx
      let ctrlValue = val;
      ctrlValue = val.replace(/\D/g, "").substring(0, 11);
      const valueLen = ctrlValue.length;
      if (valueLen > 3 && valueLen < 7) {
        ctrlValue = `${ctrlValue.substr(0, 3)}-${ctrlValue.substr(3)}`;
      } else if (valueLen >= 7) {
        ctrlValue = `${ctrlValue.substr(0, 3)}-${ctrlValue.substr(
          3,
          3
        )}-${ctrlValue.substr(6)}`;
      }
      this.phone = ctrlValue;
      // this.$set(this.requestForm, "phone", ctrlValue);
    },

    roomSearch(value) {
      if (value) {
        this.roomArray = this.roomList.filter((item) => {
          return item.name.indexOf(value) != -1;
        });
        this.notFoundContent = this.stringList.invalid_room;
      } else {
        this.roomArray = [];
        this.notFoundContent = "";
      }
    },
    roomChange(value) {
      this.$nextTick(() => {
        this.$refs.componentRef.$refs.select1.blur();
      });
      this.roomNumber = value;
      this.roomArray = this.roomList.filter((item) => {
        return item.name.indexOf(value) != -1;
      });
    },
    handleSearch(value) {
      if (this.language == "en") {
        this.otherRequestList = this.requestList.filter((item) => {
          return item.keyword.toLowerCase().indexOf(value.toLowerCase()) != -1;
        });
      } else {
        this.otherRequestList = this.requestList.filter((item) => {
          if (item[this.language]) {
            return (
              item[this.language].toLowerCase().indexOf(value.toLowerCase()) !=
              -1
            );
          }
        });
      }
    },
    handleChange(value) {
      this.searchRequest = value;
      this.otherRequestList = this.requestList.filter((item) => {
        return item.keyword.toLowerCase().indexOf(value.toLowerCase()) != -1;
      });
    },

    dateConfirm(date) {
      // console.log(moment(date.getTime()).format("YYYY/MM/DD"));
      this.date = moment(date.getTime()).format("MM/DD/YYYY");
      // 判断是否为今天
      if (
        this.date !=
        moment(new Date().getTime())
          .tz(Vue.ls.get("timeZone"))
          .format("MM/DD/YYYY")
      ) {
        this.time = "10:00 AM";
      } else {
        this.time = this.stringList.asap;
      }
      this.showDate = false;
    },
    getDefaultDate() {
      let date = moment(new Date())
        .tz(Vue.ls.get("timeZone"))
        .format("YYYY/MM/DD");
      // console.log(date);
      return new Date(date);
    },
    getMinDate() {
      let date = moment(new Date())
        .tz(Vue.ls.get("timeZone"))
        .format("YYYY/MM/DD");
      // console.log(date);
      return new Date(date);
    },
    timeConfirm(value) {
      this.showTime = false;
      this.timePickerData = value;
      this.time = value[0] + ":" + value[1] + " " + value[2];
    },
    selectTime() {
      if (this.timeDisabled) {
        this.showTime = true;
        let time = moment(new Date())
          .tz(Vue.ls.get("timeZone"))
          .format("hh:mm A");
        this.timeColumns[0].defaultIndex = Number(time.slice(0, 2)) - 1;
        this.timeColumns[1].defaultIndex = Number(time.slice(3, 5));
        this.timeColumns[2].defaultIndex =
          time.slice(time.length - 2, time.length) == "AM" ? 0 : 1;
      }
    },
    deteSelect() {
      if (this.timeDisabled) {
        this.showDate = true;
      }
    },

    showRequestPop() {
      this.requestPop = true;
      if (this.selectRequest.keyword != this.searchRequest) {
        this.searchRequest = undefined;
        this.otherRequestList = this.requestList;
      }
    },

    addRequest(request) {
      this.selectRequest = request;
      this.confirmation1 = JSON.parse(request.response)[this.language];
      console.log(this.confirmation1);
      // if (this.isJSON(request.response)) {
      //   this.selectRequest.response = JSON.parse(request.response)[
      //     this.language
      //   ];
      // }
      this.requestPop = false;
      this.fdAction = "";
      this.isUseConfirmationPop(request);
    },
    // isJSON(str) {
    //   if (typeof str == "string") {
    //     try {
    //       var obj = JSON.parse(str);
    //       if (typeof obj == "object" && obj) {
    //         return true;
    //       } else {
    //         return false;
    //       }
    //     } catch (e) {
    //       console.log("error：" + str + "!!!" + e);
    //       return false;
    //     }
    //   }
    // },
    addOtherRequest() {
      if (this.searchRequest) {
        for (let i = 0; i < this.requestList.length; i++) {
          const item = this.requestList[i];
          if (item.keyword == this.searchRequest) {
            this.selectRequest = item;
          }
        }
        this.requestPop = false;
        this.fdAction = "";
        this.isUseConfirmationPop(this.selectRequest);
        // console.log(this.selectRequest)
      }
    },

    //特殊弹窗逻辑
    isUseConfirmationPop(request) {
      console.log(request);

      //ScheduleAfterHour或者ScheduleNextDay 的requeset时间固定不可修改
      let now = new Date();
      let taody = moment(now).tz(Vue.ls.get("timeZone")).format("YYYY/MM/DD");
      let tomorrow = moment(now.getTime() + 1000 * 60 * 60 * 24)
        .tz(Vue.ls.get("timeZone"))
        .format("YYYY/MM/DD");
      this.date = "";
      this.time = "";
      this.timeDisabled = true;
      if (this.selectRequest.section == "ScheduleNextDay") {
        this.timeDisabled = false;
        let time = "";
        if (this.selectRequest.cnfgRequestTime.indexOf("Tomorrow_") != -1) {
          time = moment.tz(
            moment(
              this.selectRequest.cnfgRequestTime.replace(
                "Tomorrow_",
                tomorrow + " "
              )
            ).format("YYYY-MM-DD HH:mm"),
            Vue.ls.get("timeZone")
          );
        } else {
          time = moment.tz(
            moment(taody + " " + this.selectRequest.cnfgRequestTime).format(
              "YYYY-MM-DD HH:mm"
            ),
            Vue.ls.get("timeZone")
          );
        }
        this.date = time.format("MM/DD/YYYY");
        this.time = time.format("hh:mm A");
      }

      if (request.flow == "15") {
        // this.createOrder();
      } else if (request.section == "ScheduleAfterHour") {
        getAction(this.url.isservicehour + request.keyword).then((res) => {
          // res.data
          // eslint-disable-next-line no-constant-condition
          if (res.data == true) {
            this.fdAction = "Yes";
            this.confirmationPop = true;
            this.confirmation = JSON.parse(request.response)[this.language];

            this.timeDisabled = false;
            let time = "";
            if (this.selectRequest.cnfgRequestTime.indexOf("Tomorrow_") != -1) {
              time = moment.tz(
                moment(
                  this.selectRequest.cnfgRequestTime.replace(
                    "Tomorrow_",
                    tomorrow + " "
                  )
                ).format("YYYY-MM-DD HH:mm"),
                Vue.ls.get("timeZone")
              );
            } else {
              time = moment.tz(
                moment(taody + " " + this.selectRequest.cnfgRequestTime).format(
                  "YYYY-MM-DD HH:mm"
                ),
                Vue.ls.get("timeZone")
              );
            }
            this.date = time.format("MM/DD/YYYY");
            this.time = time.format("hh:mm A");
            // this.confirmation =
            //   "We currently only schedule next day " +
            //   request.keyword +
            //   ". Would you like me to put you down on our list for tomorrow?";
          } else {
            // this.createOrder();
          }
        });
      } else if (request.section == "ScheduleNextDay") {
        this.fdAction = "Yes";
        this.confirmationPop = true;
        this.confirmation = JSON.parse(request.response)[this.language];
        // this.confirmation =
        //   "We currently only schedule next day " +
        //   request.keyword +
        //   ". Would you like me to put you down on our list for tomorrow?";
      } else if (
        request.section == "TransferToFD" ||
        request.section == "TransferToRS"
      ) {
        this.fdAction = "No";
        this.confirmationPop = true;
        this.confirmation = this.stringList.confirmationContent;
      } else if (request.section == "CustomerDelivery") {
        this.fdAction = "No";
        this.confirmationPop = true;
        this.confirmation = this.stringList.confirmationContent2;
      } else if (request.section == "Answer") {
        this.createOrder();
      }
    },

    confirmationPopOK() {
      if (this.fdAction == "No") {
        this.createOrder();
      } else {
        this.confirmationPop = false;
      }
    },

    createOrder() {
      if (this.fdAction == "Yes" || this.fdAction == "") {
        if (!this.roomNumber && this.selectRequest.section != "Answer") {
          Toast(this.stringList.room_toast);
          return;
        }
      }

      if (!this.meetingRequest) {
        Toast(this.stringList.service_toast);
        return;
      }

      if (this.meetingRequest.length > 50) {
        Toast({
          message:
            `<div style="word-break: normal;font-size:14px;width="300px"><span>` +
            this.stringList.limit_request_description +
            `</span></div>`,
          type: "html",
        });
        return;
      }
      if (this.notes.length > 200 && this.notes.length != 0) {
        Toast({
          message:
            `<div style="word-break: normal;font-size:14px;width=300px"><span>` +
            this.stringList.limit_description +
            `</span></div>`,
          type: "html",
        });
        return;
      }

      let now = new Date();
      let createTime = moment(now).tz(Vue.ls.get("timeZone"));
      let today = moment(now).tz(Vue.ls.get("timeZone")).format("MM/DD/YY");
      let tomorrow = moment(now.getTime() + 1000 * 60 * 60 * 24)
        .tz(Vue.ls.get("timeZone"))
        .format("MM/DD/YY");

      //确定requestTime
      let date = this.date;
      if (!date) {
        date = moment(new Date())
          .tz(Vue.ls.get("timeZone"))
          .format("YYYY/MM/DD");
      }
      let time = this.time;
      if (!time || time == this.stringList.asap) {
        time = moment(new Date()).tz(Vue.ls.get("timeZone")).format("hh:mm A");
      }
      let requestTime = moment.tz(
        moment(date + " " + time).format("YYYY-MM-DD HH:mm"),
        Vue.ls.get("timeZone")
      );

      if (requestTime.valueOf() + 180000 < now.getTime()) {
        Toast(this.stringList.time_toast);
        return;
      }
      // if (!this.phone || this.phone.length !== 12) {
      //   Toast(this.stringList.phone_toast);
      //   return;
      // }
      if (this.showPhone == 2) {
        if (!this.phone) {
          Toast(this.stringList.optional4);
          return;
        }
      }
      if (this.phone && this.phone.length !== 12) {
        Toast(this.stringList.phone_toast);
        return;
      }

      // if (!this.date && !this.time) {
      //   this.tips = this.stringList.tipsContent1;
      // } else {
      //   if (Vue.ls.get("type") == "nonguest") {
      //     this.tips = this.meetingRequest;
      //   } else {
      //     if (requestTime.format("MM/DD/YY") == today) {
      //       this.tips =
      //         this.stringList.tipsContent2 +
      //         requestTime.format("hh:mm A") +
      //         ".";
      //     } else if (requestTime.format("MM/DD/YY") == tomorrow) {
      //       this.tips =
      //         this.stringList.tipsContent3 +
      //         requestTime.format("hh:mm A") +
      //         ".";
      //     } else {
      //       this.tips =
      //         this.stringList.tipsContent4 +
      //         requestTime.format("MM/DD/YY hh:mm A") +
      //         ".";
      //     }
      //   }
      // }
      this.tips = this.meetingRequest;

      if (
        (this.selectRequest.section == "ScheduleAfterHour" &&
          this.fdAction == "Yes") ||
        this.selectRequest.section == "ScheduleNextDay"
      ) {
        let time = moment(new Date()).tz(Vue.ls.get("timeZone"));
        if (this.selectRequest.cnfgRequestTime.indexOf("Tomorrow_") != -1) {
          time = moment.tz(
            moment(
              this.selectRequest.cnfgRequestTime.replace(
                "Tomorrow_",
                tomorrow + " "
              )
            ).format("YYYY-MM-DD HH:mm"),
            Vue.ls.get("timeZone")
          );
        } else {
          time = moment.tz(
            moment(today + " " + this.selectRequest.cnfgRequestTime).format(
              "YYYY-MM-DD HH:mm"
            ),
            Vue.ls.get("timeZone")
          );
        }
        if (time.format("MM/DD/YY") == today) {
          this.tips = this.stringList.tipsContent6;
        } else if (time.format("MM/DD/YY") == tomorrow) {
          this.tips = this.stringList.tipsContent5;
        } else {
          this.tips =
            this.stringList.tipsContent4 + time.format("MM/DD/YY") + ".";
        }
      } else if (this.selectRequest.section == "ScheduleAfterHour") {
        if (requestTime.format("MM/DD/YY") == today) {
          this.tips = this.stringList.tipsContent6;
        } else if (requestTime.format("MM/DD/YY") == tomorrow) {
          this.tips = this.stringList.tipsContent5;
        } else {
          this.tips =
            this.stringList.tipsContent4 + requestTime.format("MM/DD/YY") + ".";
        }
      }
      let time1 = new Date().valueOf().toString();
      let params = {
        hotelId: Vue.ls.get("hotelId"),
        fdaction: this.fdAction,
        createTime: createTime.utc().format(),
        fdhour: Vue.ls.get("overNightHoursInfo"),
        hotelDeptId: this.selectRequest.hotelDeptId,
        inquiryNum: "",
        notes: this.notes,
        requestType: Vue.ls.get("type"),
        roomNumber: this.roomNumber ? this.roomNumber : "None",
        requestTime: requestTime.utc().format(),
        serviceKey: this.meetingRequest,
        serviceType: this.meetingServiceType,
        phone: this.phone,
        createTimeValue: time1,
        tid: encryptedDES(time1.substring(time1.length - 8)),
        language: this.language,
      };
      if (
        Vue.ls.get("overNightHoursInfo") == "Front Desk Hour" ||
        Vue.ls.get("overNightHoursInfo") == "Cycle Front Desk Hour"
      ) {
        params.fdhour = Vue.ls.get("fdOption");
      } else if (
        Vue.ls.get("overNightHoursInfo") == "Cycle Regular Operating Hour"
      ) {
        params.fdhour = "Regular Operating Hour";
      }
      if (this.fdAction == "No") {
        params.status = "Complete-Bot";
      }

      if (!this.submiting) {
        this.submiting = true;
        postAction(this.url.createOrder, params)
          .then((res) => {
            if (res.success) {
              if (this.fdAction == "No") {
                // this.$router.go(-1);
                let query = {};
                query.type = this.$route.query.type;
                query.inno = this.$route.query.inno;
                if (this.$route.query.room) {
                  query.room = this.$route.query.room;
                }
                query.tsp = this.$route.query.tsp;
                this.$router.replace({ name: "Home", query: query });
              } else {
                this.submiting = false;
                if (
                  this.selectRequest.section == "TransferToFD" ||
                  this.selectRequest.section == "TransferToRS" ||
                  this.selectRequest.flow == "15"
                ) {
                  this.thankPop2 = true;
                } else if (this.selectRequest.section == "Answer") {
                  this.thankPop3 = true;
                } else {
                  this.thankPop = true;
                }

                this.okContent = res.msg;
              }
            } else {
              this.submiting = false;
              Toast(res.msg);
            }
          })
          .catch((e) => {
            this.submiting = false;
          });
      }
    },
    focusMeetingRequest(str) {
      if (this.meetingRequest !== str) {
        this.meetingRequest = str;
        return;
      }
      if (this.meetingRequest == str) {
        this.meetingRequest = "";
        return;
      }
    },
  },
};
</script>
